const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN;
const ENV = import.meta.env.VITE_ENV;
const API_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, "");
const WEBSOCKET_URL = import.meta.env.VITE_PUBLIC_WEBSOCKET_URL?.replace(
  /\/$/,
  "",
);

export const getApiUrl = (appPath?: string) => {
  const suffix = appPath ? `/${appPath.replace(/^\/+/, "")}` : "";
  if (API_URL) return `${API_URL}${suffix}`;

  const protocol = ENV === "DEV" ? "http" : "https";
  const baseUrl = ENV === "DEV" ? `${ROOT_DOMAIN}:8000` : `core.${ROOT_DOMAIN}`;
  return `${protocol}://${baseUrl}/api${suffix}`;
};

export const getCookieDomain = () => {
  const configuredDomain = import.meta.env.VITE_COOKIE_DOMAIN?.trim();
  if (configuredDomain) return configuredDomain;
  return ENV === "DEV" ? undefined : `.${ROOT_DOMAIN}`;
};

export const getWebsocketUrl = () => {
  if (WEBSOCKET_URL) return WEBSOCKET_URL;

  // DEV -> ws://127.0.0.1:8888
  // PROD -> wss://core.great-escape-sports.org/ws
  const protocol = ENV === "DEV" ? "ws" : "wss";

  const url = ENV === "DEV" ? `${ROOT_DOMAIN}:8888` : `core.${ROOT_DOMAIN}/ws`;

  return `${protocol}://${url}`;
};
